import { useSetAtom } from 'jotai';
import { chatFeedWriteAtom } from '../atoms';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

function useHandleUserMessage({ getStream }) {
  const updateLastChatBlock = useSetAtom(chatFeedWriteAtom);

  const submitQuestion = (userMsg) => {
    // new chat
    updateLastChatBlock(
      {
        userMsg,
      },
      true,
    );

    getStream({
      query: userMsg,
      product: CURRENT_PRODUCT_MODE,
    });
  };

  return { submitQuestion };
}

export default useHandleUserMessage;
